import Icon from "@Components/ui/icon/Icon";
import classes from "./AccordionButton.module.scss";

export default function AccordionButton(props: any) {
  return (
    <div
      className={`${classes["chevron-container"]} ${
        props.active ? classes["chevron-container__opened"] : ""
      }`}
      onClick={props.onClick}
    >
      <Icon iconName={props?.iconName ? props?.iconName : "DownwardChevron"} />
    </div>
  );
}
